/*
  RootWrapper.tsx
  (c) Human Cube Inc.
*/

import React, { useState, useEffect } from 'react';

import Root from './Root';


const RootWrapper = (props: any) => {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => { window.removeEventListener('resize', handleResize) }
  }, []);

  return <Root dimensions={dimensions} />;
}

export default RootWrapper;
